import Iconify from '@emfood/shared/src/components/iconify';

import { Stack, Typography } from '@mui/material';

import { OrderIssueModel, OrderIssueReplyCreatedBy } from 'src/api/models/orders';

interface IssueStatusProps {
  issue: OrderIssueModel;
}

export default function IssueStatus({ issue }: IssueStatusProps) {
  let icon = '';
  let text = '';
  let color = '';

  const lastReply = issue.replies.length > 0 ? issue.replies[issue.replies.length - 1] : undefined;

  if (issue.replies.length > 0 && lastReply?.reconciled) {
    icon = 'eva:checkmark-circle-2-fill';
    text = 'Issue Resolved';
    color = 'success.main';
  } else if (issue.replies.length === 4) {
    icon = 'eva:close-circle-fill';
    text = 'Issue Unresolved';
    color = 'error.main';
  } else if (
    issue.replies.length === 0 ||
    Number(lastReply?.createdByEntity) === OrderIssueReplyCreatedBy.BUYER
  ) {
    icon = 'eva:alert-triangle-fill';
    text = 'Awaiting Distributor Response';
    color = 'grey.500';
  } else if (Number(lastReply?.createdByEntity) === OrderIssueReplyCreatedBy.DISTRIBUTOR) {
    icon = 'eva:alert-triangle-fill';
    text = 'Awaiting Your Response';
    color = 'warning.main';
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Iconify icon={icon} sx={{ color }} />
      <Typography variant="body2" sx={{ color }}>
        {text}
      </Typography>
    </Stack>
  );
}
